export default "__VITE_ASSET__CZYHBsjE__"